import { render, staticRenderFns } from "./default.vue?vue&type=template&id=30a46681"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreAppBar: require('/app/components/core/AppBar.vue').default,CoreDrawer: require('/app/components/core/Drawer.vue').default,CoreView: require('/app/components/core/View.vue').default,CoreFooter: require('/app/components/core/Footer.vue').default})
